import * as React from "react";
import { useParams } from "react-router-dom";
import { LinkContainer } from "components/common";
import { Button, ButtonToolbar } from "components/bootstrap";
import SearchFiltersRoutes from "search-filter/Routes";
const SearchFilterPageSubactions = () => {
  const { filterId } = useParams();
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: SearchFiltersRoutes.SHOW(filterId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, "View Filter And Usages")), /* @__PURE__ */ React.createElement(LinkContainer, { to: SearchFiltersRoutes.EDIT(filterId) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, "Edit Filter")));
};
export default SearchFilterPageSubactions;
